import React from 'react';
import tw, { styled } from 'twin.macro';

interface ComponentProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  danger?: boolean;
  link?: boolean;
  disabled?: boolean;
  outline?: boolean;
}

const Button = styled.button<ComponentProps>`
  ${tw`block text-base rounded py-2 px-4 font-medium`}
  ${tw`bg-gray-300 text-gray-900 hover:bg-gray-400`}
  ${(props) => props.primary && tw`bg-blue-800 text-white hover:bg-blue-900`}
  ${(props) => props.danger && tw`bg-red-500 text-white hover:bg-red-800`}
  ${(props) => props.disabled && tw`opacity-25`}
   ${(props) =>
    props.link &&
    tw`!p-0 text-gray-900 inline-block leading-6 bg-transparent hover:bg-transparent underline hover:text-blue-500 font-normal text-base rounded-none`}
  ${(props) =>
    props.outline &&
    tw`inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
`;

function CommonButtonDefault({ children, ...rest }: ComponentProps) {
  return <Button {...rest}>{children}</Button>;
}

CommonButtonDefault.defaultProps = {
  primary: false,
  danger: false,
  disabled: false,
  link: false,
  outline: false,
};

export default CommonButtonDefault;
